import { Button, HStack, Tooltip } from "@chakra-ui/react";
import { FunctionComponent, ReactElement } from "react";

interface StepperFooterProps {
	hasPreviousStep: boolean;
	isPreviousDisabled?: boolean;
	isPreviousLoading?: boolean;
	hasNextStep?: boolean;
	isNextDisabled?: boolean;
	isNextLoading?: boolean;
	nextTooltip?: string;
	isSubmit?: boolean;
	isSubmitDisabled?: boolean;
	isSubmitLoading?: boolean;

	onPrevious?: () => void;
	onNext?: () => void;
	onSubmit?: () => void;
}

const StepperFooter: FunctionComponent<StepperFooterProps> = (props: StepperFooterProps): ReactElement => {
	const {
		hasPreviousStep,
		isPreviousDisabled = false,
		isPreviousLoading = false,
		hasNextStep = true,
		isNextDisabled = false,
		isNextLoading = false,
		nextTooltip = "",
		isSubmit = false,
		isSubmitDisabled = false,
		isSubmitLoading = false,
		onPrevious,
		onNext,
		onSubmit
	} = props;

	return (
		<HStack width="100%" mt="auto">
			{hasPreviousStep && (
				<HStack>
					<Button
						colorScheme="blackAlpha"
						onClick={() => onPrevious && onPrevious()}
						isDisabled={isPreviousDisabled || isPreviousLoading}
						isLoading={isPreviousLoading}>
						Previous
					</Button>
				</HStack>
			)}
			{hasNextStep && (
				<HStack marginLeft="auto">
					<Tooltip label={nextTooltip}>
						<Button
							colorScheme="orange"
							onClick={() => onNext && onNext()}
							isDisabled={isNextDisabled || isNextLoading}
							isLoading={isNextLoading}>
							Next
						</Button>
					</Tooltip>
				</HStack>
			)}
			{isSubmit && (
				<HStack marginLeft="auto">
					<Button
						colorScheme="orange"
						onClick={() => onSubmit && onSubmit()}
						isDisabled={isSubmitDisabled || isSubmitLoading}
						isLoading={isSubmitLoading}>
						Submit
					</Button>
				</HStack>
			)}
		</HStack>
	);
};

export default StepperFooter;
